import React, { useState, useEffect } from "react";
import api from "../../services/api";
import * as S from "./styles";
import { toast } from "react-toastify";

const ListCategoryStoreType = ({ onChange, ...props }) => {
  const [valueValid, setValueValid] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const [listCategoryStoreType, setListCategoryStoreType] = useState([]);

  useEffect(() => getAllCategoryStoreType(), []);

  async function getAllCategoryStoreType() {
    setIsLoading(true);
    try {
      const response = await api.get(`/api/loja/categorias`);

      if (
        response?.data &&
        (response.status === 201 || response.status === 200)
      ) {
        let listCategoryStoreType = response?.data || [];

        if (listCategoryStoreType.length != 0) {
          listCategoryStoreType = [
            { id: 0, descricao: "Selecione...", ordem: 0 },
          ].concat(listCategoryStoreType);
        }

        setListCategoryStoreType(listCategoryStoreType);

        const optionsResult = listCategoryStoreType.map((currOption, index) => {
          return (
            <S.Option key={index} value={currOption.id}>
              {currOption.descricao}
            </S.Option>
          );
        });

        setOptions(optionsResult);
      } else if (!response) {
        toast.error(
          "Erro ao buscar as Categorias de Loja, tente novamente mais tarde!"
        );
      }
    } catch (err) {
      if (err?.response?.data?.message) {
        toast.error(err?.response?.data?.message);
      } else {
        toast.error(
          "Erro ao buscar as Categorias de Loja, tente novamente mais tarde!"
        );
      }
    } finally {
      setIsLoading(false);
    }
  }

  function getCategoryStoreTypeById(id) {
    let categoryStoreType = null;
    if (id !== 0) {
      listCategoryStoreType.every(function (currCategoryStoreType) {
        if (id === Number(currCategoryStoreType.id)) {
          categoryStoreType = currCategoryStoreType;
          return false;
        }
        return true;
      });
    }
    return categoryStoreType;
  }

  return isLoading ? (
    <></>
  ) : (
    <>
      <S.Label {...props}>{props.label}</S.Label>
      <S.Select
        {...props}
        valueValid={valueValid}
        onChange={(e) => {
          const id = Number(e.target.value);

          setValueValid(id !== 0);

          onChange(getCategoryStoreTypeById(id));
        }}
      >
        {options}
      </S.Select>
    </>
  );
};

export default ListCategoryStoreType;
